module.exports = "/fonts/vendor/material-icons/iconmaterial-icons-sharp.woff?6efac2316204505e0e8882b391df7d13";